import React, { useEffect, useState } from "react";
import {
  Button,
  Input,
  Table,
} from "reactstrap";

import { BiSearchAlt2 } from "react-icons/bi";
import { RiDeleteBin6Line } from "react-icons/ri";
import { GrEdit, GrAddCircle } from "react-icons/gr";

import noavatar from "../../../assets/img/noavatar.png";
import { getData } from "../../../api/method";
import Pagination from "../../pagination";

function TableProduct({args,toggleAdd,getProductByDel,getProductByEdit}) {
  const [search, setSearch] = useState("");
  const [data, setData] = useState([]);

  const getProduct = async () => {
    try {
      const result = await getData("/api/Product");
      setData(result.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getProduct();
  }, [data]);

  const [currentPage, setCurrentPage] = useState(1);
  const [dataPerPage, setDataPerPage] = useState(8);

  const indexOfLastData = currentPage * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;
  const currentData = data.slice(indexOfFirstData, indexOfLastData);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <div>
      <div className="d-flex align-items-center line_border--admin">
        <BiSearchAlt2 className="t-grey ms-2" />

        <Input
          className="border-0"
          placeholder="Enter you keyword..."
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <div className="pt-4">
        <div className="d-flex justify-content-between pb-4">
          <Button
            className="btn_add fs-20 d-flex align-items-center"
            onClick={toggleAdd}
          >
            <GrAddCircle className="me-2" />
            Add
          </Button>
        </div>

        <Table className="table_admin">
          <thead>
            <tr className="fw-bold">
              <th className="table_p_stt">#</th>
              <th className="table_p_img">Image</th>
              <th className="table_p_name">Name</th>
              <th className="table_p_trademark">Category</th>
              <th className="table_p_price">Brand</th>
              <th className="table_p_price">Price</th>
              <th className="table_p_percent">Discount</th>
              <th className="table_p_dimension">Dimension</th>
              <th className="table_p_quantity">Quantity</th>
              <th className="table_p_sell">Sell</th>
              <th className="table_p_quantity">Active</th>
              <th className="table_p_act" colSpan={2}></th>
            </tr>
          </thead>
          <tbody>
            {currentData
              ?.sort((a, b) => b.id - a.id)
              .filter((item) => {
                if (search === "") {
                  return item;
                } else if (
                  item.name.toLowerCase().includes(search.toLowerCase()) ||
                  item.category.name
                    .toLowerCase()
                    .includes(search.toLowerCase()) ||
                  item.brand.name.toLowerCase().includes(search.toLowerCase())
                ) {
                  return item;
                }
              })
              .map((item, index) => (
                <tr key={index}>
                  <td className="table_p_stt">{index}</td>
                  <td className="table_p_img">
                    <img
                      src={
                        `${process.env.REACT_APP_URL_IMAGE + item.image}` ||
                        noavatar
                      }
                      alt="product"
                      width={50}
                      height={50}
                    />
                  </td>
                  <td className="table_p_name">
                    {" "}
                    <div className=" table_p_name--custom">
                      {item.name}
                    </div>{" "}
                  </td>
                  <td className="table_p_trademark t-capitalize">
                    {" "}
                    {item.category.name}{" "}
                  </td>
                  <td className="table_p_price t-capitalize">
                    {" "}
                    {item.brand.name}{" "}
                  </td>
                  <td className="table_p_price">
                    {item.price.toLocaleString("vi")}&#273;
                  </td>
                  <td className="table_p_percent">{item.discount}%</td>
                  <td className="table_p_dimension">{item.dimension}ml</td>
                  <td className="table_p_quantity">
                    {item.quantity + item.soldQuantity}{" "}
                  </td>
                  <td className="table_p_sell">{item.soldQuantity}</td>
                  <td
                    className={`table_p_quantity ${
                      item.quantity > 0 ? "" : "t-red"
                    }`}
                  >
                    {" "}
                    {item.quantity > 0 ? "Stocking" : "Sold out"}{" "}
                  </td>
                  <td
                    className="table_p_act_1"
                    onClick={() => getProductByEdit(item.id)}
                  >
                    {" "}
                    <GrEdit className="fs-4" />{" "}
                  </td>
                  <td
                    className="table_p_act_2"
                    onClick={() => getProductByDel(item.id)}
                  >
                    {" "}
                    <RiDeleteBin6Line className="fs-4" />{" "}
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>

        <Pagination
          paginate={paginate}
          postsPerPage={dataPerPage}
          totalPosts={data.length}
        />
      </div>
    </div>
  );
}

export default TableProduct;
